import { Controller } from "@hotwired/stimulus"

// Gates an embedded video player (documents/_video_embed.html.erb) on real
// connectivity (card #4515, Playbooks video slice 2). The Field App caches
// its page shells offline (Field::PlaybookEntriesController, offline_capable
// strategy: :cache) but never the video itself or its signed URL -- the
// feature's README is explicit that video stays out of the offline
// manifest -- so a Tasker who opens an entry while offline would otherwise
// see a <video> element trying and failing to load. This swaps in a plain
// "Needs a connection to play" message instead of a broken player.
//
// navigator.onLine is checked at connect and kept in sync with the
// online/offline window events -- the same signal pwa/network_status_controller
// uses, but this controller has no ping/poll of its own: a false positive
// ("online" but no real internet) just means the video buffers, not that it
// fails outright, so the plain browser signal is trusted as-is. Everywhere
// outside the Field App's offline cache (Help Centre, Mission Control) the
// browser is online whenever the page itself loaded at all, so this is a
// no-op there.
export default class extends Controller {
  static targets = ["player", "offline"]

  connect() {
    this._update()
    this._onlineHandler = () => this._update()
    window.addEventListener("online", this._onlineHandler)
    window.addEventListener("offline", this._onlineHandler)
  }

  disconnect() {
    window.removeEventListener("online", this._onlineHandler)
    window.removeEventListener("offline", this._onlineHandler)
  }

  _update() {
    const online = navigator.onLine !== false
    if (this.hasPlayerTarget) this.playerTarget.classList.toggle("hidden", !online)
    if (this.hasOfflineTarget) this.offlineTarget.classList.toggle("hidden", online)
  }
}
